type TicketMeta = {
	author: {
		id: number | null;
	};
};

export type ChatMessage = {
	content: string;
	meta: object | null;
	createdAt: Date;
	updatedAt: Date;
	authorId: number;
};

export const getNextChatMessages = (
	messages: ChatMessage[],
	meta: TicketMeta,
	content: string,
	now: Date = new Date(),
) => {
	return [
		...messages,
		{
			content,
			meta: null,
			createdAt: now,
			updatedAt: now,
			authorId: meta.author.id ?? 0,
		},
	];
};

export const getHistoryChatMessages = (messages: ChatMessage[]) => {
	return messages.map((message) => ({
		...message,
		createdAt: new Date(message.createdAt),
		updatedAt: new Date(message.updatedAt),
	}));
};
